import Category from "../models/Category"

export const CategoryMixin = {
  data() {
    return {
      category: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Category({
        title: '',
        description: '',
        slug: undefined,
        is_public: 0,
        icon: undefined,
      })
    }
  }
}
